
import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss']
})

export class PopoverComponent implements OnInit, OnDestroy {
  @Input() titleText: string;
  @Input() scrollable: boolean;
  @Input() size: 'small' | 'medium' | 'large' | 'xlarge' | 'full';
  @Input() fullHeight: boolean;
  @Input() customStyle: string;
  @Input() sendHeader: boolean;
  @Input() subheaderText: string;
  @Input() mergerModal = false;
  @Input() policyPopup = false;


  @Output() closeCallback = new EventEmitter();

  ngOnInit() {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  }

  onCloseClick = (): void  => {
    this.closeCallback.emit();
  }

  ngOnDestroy() {
    document.getElementsByTagName('html')[0].style.overflow = 'auto';
  }

}
